exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form .col-md-3{width:40%}.table td{padding:5px 10px}.modal{display:block}.modal-backdrop,.modal-dialog{transition:all .5s ease}.modal-enter .modal-dialog,.modal-leave-active .modal-dialog{opacity:0;transform:translateY(-30%)}.modal-enter .modal-backdrop,.modal-leave-active .modal-backdrop{opacity:0}.modal-backdrop{opacity:.5}//Modal styles .modal-header{height:auto;padding:0 1.6rem;border-bottom:2px solid #eee;font-size:1.2rem;display:flex;align-items:center}.modal-content{border-radius:0}.modal-footer{justify-content:center;padding:0 2px;padding-bottom:5px;flex-wrap:wrap;.btn{margin:0 10px 20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8ed30746","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/metabase/reports.vue
// module id = 671
// module chunks = 27